import { render } from "./InformeBaremos.vue?vue&type=template&id=bb77a4b2&scoped=true"
import script from "./InformeBaremos.vue?vue&type=script&lang=js"
export * from "./InformeBaremos.vue?vue&type=script&lang=js"

import "./InformeBaremos.vue?vue&type=style&index=0&id=bb77a4b2&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb77a4b2"]])

export default __exports__